import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboardService';

const STALE_TIME = 2 * 60 * 1000; // 2 minutes

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: () => dashboardService.getStats(),
    staleTime: STALE_TIME,
  });
}

export function useNcrTrend() {
  return useQuery({
    queryKey: ['dashboard', 'ncr-trend'],
    queryFn: () => dashboardService.getNcrTrend(),
    staleTime: STALE_TIME,
  });
}

export function useNcrBySource() {
  return useQuery({
    queryKey: ['dashboard', 'ncr-by-source'],
    queryFn: () => dashboardService.getNcrBySource(),
    staleTime: STALE_TIME,
  });
}

export function useObjectivesProgress() {
  return useQuery({
    queryKey: ['dashboard', 'objectives-progress'],
    queryFn: () => dashboardService.getObjectivesProgress(),
    staleTime: STALE_TIME,
  });
}

export function useRecentActivity() {
  return useQuery({
    queryKey: ['dashboard', 'recent-activity'],
    queryFn: () => dashboardService.getRecentActivity(),
    staleTime: STALE_TIME,
  });
}

export function usePendingApprovals() {
  return useQuery({
    queryKey: ['dashboard', 'pending-approvals'],
    queryFn: () => dashboardService.getPendingApprovals(),
    staleTime: STALE_TIME,
  });
}

export function useTopKpiProgress() {
  return useQuery({
    queryKey: ['dashboard', 'top-kpi-progress'],
    queryFn: () => dashboardService.getTopKpiProgress(),
    staleTime: STALE_TIME,
  });
}

export function useComplianceTrend() {
  return useQuery({
    queryKey: ['dashboard', 'compliance-trend'],
    queryFn: () => dashboardService.getComplianceTrend(),
    staleTime: STALE_TIME,
  });
}
